import { render, staticRenderFns } from "./maquetador.vue?vue&type=template&id=6fd05d13&scoped=true"
import script from "./maquetador.vue?vue&type=script&lang=js"
export * from "./maquetador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd05d13",
  null
  
)

export default component.exports